import { isMobileOrTablet } from "Utils/DeviceDetectHelpers";

export default store => ({
  path: "student",
  onEnter: (nextState, replace) => {
    const queryString = nextState.location.search || "";

    // Get sub-path after /student
    const splat = nextState.params.splat || "";
    if (isMobileOrTablet()) {
      replace(`/app-download/student/${splat}${queryString}`);
    } else {
      replace(`/${splat}${queryString}`);
    }
  },
});
